import React from 'react';
import T from 'i18n';
import { Grid } from '@mui/material';
import { ToggleForm } from 'features/common';
import { FolderContent } from '../types';

const LegacyReindexContent = ({ register }) => {
  return (
    <div>
      <span>{T.translate('case.reIndexTitleMessage')}</span>
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={6}>
          <ToggleForm
            {...register('reindexExtractEntities')}
            defaultValue={false}
            label={T.translate(`case.reindexExtractEntities`)}
          />
        </Grid>
        <Grid item xs={6}>
          <ToggleForm
            {...register('reindexExtractDates')}
            defaultValue={false}
            label={T.translate(`case.reindexExtractDates`)}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={6}>
          <ToggleForm
            {...register('reindexGenerateJson')}
            defaultValue={false}
            label={T.translate(`case.reindexGenerateJson`)}
          />
        </Grid>
        <Grid item xs={6}>
          <ToggleForm
            {...register('reindexUpdateSearchIndex')}
            defaultValue={false}
            label={T.translate(`case.reindexUpdateSearchIndex`)}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={6}>
          <ToggleForm
            {...register('reindexUpdatePinecone')}
            defaultValue={false}
            label={T.translate(`case.reindexUpdatePinecone`)}
          />
        </Grid>
        <Grid item xs={6}>
          <ToggleForm
            {...register('failedEmbeddings')}
            defaultValue={false}
            label={T.translate(`case.failedEmbeddings`)}
          />
        </Grid>
        <Grid item xs={6}>
          <ToggleForm
            {...register('clearCurrentJob')}
            defaultValue={false}
            label={T.translate(`case.clearCurrentJob`)}
          />
        </Grid>
        <Grid item xs={6}>
          <ToggleForm
            {...register('reindexEmailConfidence')}
            defaultValue={false}
            label={T.translate(`case.reindexEmailConfidence`)}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default LegacyReindexContent;
